<a class="skip-link" href="#main-content">Skip to content</a>
<gl-site-header />
<main id="main-content"><router-outlet /></main>
<gl-site-footer />
<gl-flower-click-effect />
